export const getWaterMetadataDescription = (
  name: string,
  nearestPlaceName: string | undefined,
  regionName: string | null | undefined,
  regionCode: string | null | undefined,
  countryName: string | undefined,
): string => {
  const postfix =
    '✅ Check the latest fishing reports from the local anglers 🏆 Follow local fishing regulations ➡ Fish smarter with weather forecasts from Fishbrain';

  if (!nearestPlaceName && !regionName && !countryName) {
    return `${name} ${postfix}`;
  }

  if (!nearestPlaceName && (regionName || countryName)) {
    const regionAndCountry =
      regionName && countryName ? `${regionName} (${countryName})` : regionName || countryName;
    return `${name} fishing in ${regionAndCountry} ${postfix}`;
  }

  if (nearestPlaceName && (regionName || countryName)) {
    const regionAndCountry =
      regionCode && countryName
        ? `, ${regionCode} (${countryName})`
        : `, ${regionCode || countryName}`;
    return `${name} fishing near ${nearestPlaceName}${regionAndCountry} ${postfix}`;
  }

  return `${name} fishing near ${nearestPlaceName} ${postfix}`;
};
